module.exports = __webpack_public_path__ + "img/compra.711fafd2.svg";